import { render, staticRenderFns } from "./table-only.vue?vue&type=template&id=d2eff808"
import script from "./table-only.vue?vue&type=script&lang=js"
export * from "./table-only.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports